/**
 * @ngdoc module
 * @name vrm.core
 * @description VRM core module
 */

(function() {
    "use strict";

    angular.module("vrm.core").config(DynamicESSReportingConfig);

    /**
     * @constructor
     * @ngInject
     */
    function DynamicESSReportingConfig($stateProvider) {
        $stateProvider.state("base.installation.reporting.dynamic-ess", {
            url: "/dynamic-ess",
            views: {
                reporting: {
                    template: require("@/angular/views/core/installation/reporting/dynamic-ess-reporting.html"),
                    controller: "DynamicESSReportingController"
                }
            }
        });
    }
})();
